import React, { useState } from "react";
import { usePost } from "seed/api";
import swal from "sweetalert";
import l from "components/util/l";
import View from "components/presentation/environments/ManageEnvironment.view";

function ManageEnvironment({ flow, environments, onChanged, onDeleted, onClickMerge }) {

  const [panel, setPanel] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [deletingId, setDeletingId] = useState(null);

  const [callCreate, reqCreate] = usePost("/flows/create_environment", {
    onCompleted: (data) => { window.location.href = `/app/?flow_id=${data.flow_id}`; },
    onError: () => swal(l("Error%GA114"), l("No se pudo crear el entorno%EN014"), "error")
  });

  const [callRename, reqRename] = usePost("/flows/rename_environment", {
    onCompleted: () => { setEditingId(null); onChanged(); },
    onError: (error) => swal(l("Error%GA114"), error?.detail || l("No se pudo renombrar el entorno%EN031"), "error")
  });

  const [callDelete, reqDelete] = usePost("/flows/delete_environment", {
    onCompleted: () => onDeleted(deletingId),
    onError: (error) => swal(l("Error%GA114"), error?.detail || l("No se pudo eliminar el entorno%EN001"), "error")
  });

  const rows = environments.map((item) => ({
    id: item.id,
    environment: item.environment,
    environmentName: item.environment_name,
    isRoot: item.is_root,
    isCurrent: item.id == flow.id,
    isEditable: item.environment == "CUSTOM",
  }));

  const onClickPanel = (next) =>
    setPanel(panel == next ? null : next);

  const onSubmitCreate = (name) =>
    callCreate({ source_flow_id: flow.id, environment: "CUSTOM", environment_name: name });

  const onSubmitRename = (environmentId, name) =>
    callRename({ flow_id: environmentId, environment_name: name });

  const onClickDelete = (row) => {
    swal({
      title: l("¿Eliminar entorno?%EN002"),
      text: l("Se elimina el entorno y todo lo que contiene. Los demás entornos no se tocan.%EN003"),
      icon: "warning",
      buttons: {
        confirm: { text: l("Aceptar%GA020"), className: "swal-button swal-button--cancel btn-danger" },
        cancel: l("Cancelar%GA021")
      }
    }).then((willDelete) => {
      if (!willDelete) return;
      setDeletingId(row.id);
      callDelete({ flow_id: row.id });
    });
  }

  return (
    <View
      rows={rows}
      panel={panel}
      editingId={editingId}
      // Publishing goes from one environment to another, so a project that has only one
      // has nowhere to publish to.
      isMergeable={rows.length > 1}
      isSaving={reqCreate.loading || reqRename.loading || reqDelete.loading}
      onClickPanel={onClickPanel}
      onSubmitCreate={onSubmitCreate}
      onClickEdit={setEditingId}
      onClickCancelEdit={() => setEditingId(null)}
      onSubmitRename={onSubmitRename}
      onClickDelete={onClickDelete}
      onClickMerge={onClickMerge}
    />
  );

}

export default ManageEnvironment;
